import { RootState } from '../../store'
import { usersAdapter } from './slice'

export const entityAdapterSelectors = usersAdapter.getSelectors<RootState>(
  (state) => state.users
)

export const {
  selectAll: selectAllUsers,
  selectById: selectUserById,
  selectIds: selectUserIds,
  selectEntities: selectUserEntities,
  selectTotal: selectTotalUsers
} = entityAdapterSelectors
